<template>
  <picture>
    <source 
      v-for="(val, key, index) in sources"
      :key="index"
      :srcset="val"
      :type="`image/${key}`"
    >
    <img 
      :src="fallbackSrc"
    >
  </picture>
</template>
<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  imageName: string
  rootUrl?: string
  densities: string[] // pixel density descriptors e.g. '1x'
  formats: string[] // e.g. jpg, webp, in order of preference
}>(), {
  rootUrl: 'https://static.serato.com/visualizer/images/'
})

const sources = computed(() => {
  const sources: Record<string, string> = {}
  for (const format of props.formats) {
    let sourceSet = ''
    for (const density of props.densities) {
      sourceSet += `${props.rootUrl}${props.imageName}-${density}.${format} ${density}, ` // e.g. "imagename-1x.webp 1x"
    }
    sources[format] = sourceSet
  }
  return sources
})

const fallbackSrc = computed(() => {
  const fallbackFormat = props.formats[props.formats.length-1] 
  return `${props.rootUrl}${props.imageName}-${props.densities[0]}.${fallbackFormat}`
})

</script>
